/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type Notifications_user = {
    readonly activePromotion: {
        readonly adjustmentRateList: ReadonlyArray<{
            readonly reference: string | null;
        } | null> | null;
        readonly serviceId: string | null;
        readonly code: string | null;
        readonly flatAdjustmentRate: {
            readonly rate: {
                readonly currency: Currency | null;
                readonly amount: number | null;
            } | null;
        } | null;
        readonly percentAdjustmentRate: {
            readonly rate: number | null;
        } | null;
    } | null;
    readonly activityFeed: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly type: string | null;
                readonly eventDate: string | null;
                readonly serviceId: string | null;
            } | null;
        } | null> | null;
        readonly " $fragmentRefs": FragmentRefs<"ActivityFeed_feed">;
    } | null;
    readonly preferences: {
        readonly shareActivities: boolean | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"ShareActivityAlert_user">;
    readonly " $refType": "Notifications_user";
};
export type Notifications_user$data = Notifications_user;
export type Notifications_user$key = {
    readonly " $data"?: Notifications_user$data;
    readonly " $fragmentRefs": FragmentRefs<"Notifications_user">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "Notifications_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "activePromotion",
      "storageKey": null,
      "args": null,
      "concreteType": "Promotion",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "adjustmentRateList",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "reference",
              "args": null,
              "storageKey": null
            }
          ]
        },
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "code",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "flatAdjustmentRate",
          "storageKey": null,
          "args": null,
          "concreteType": "FlatAdjustmentRate",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "rate",
              "storageKey": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "currency",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "amount",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "percentAdjustmentRate",
          "storageKey": null,
          "args": null,
          "concreteType": "PercentAdjustmentRate",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "rate",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "activityFeed",
      "storageKey": "activityFeed(elementTypes:[\"PENDING_FEEDBACK\",\"TRADE_REWARD\",\"TRADE_REWARD_PRORATED\",\"TRADE_REWARD_PROGRAM\",\"AUTOMATED_OFFER\"],first:3)",
      "args": [
        {
          "kind": "Literal",
          "name": "elementTypes",
          "value": [
            "PENDING_FEEDBACK",
            "TRADE_REWARD",
            "TRADE_REWARD_PRORATED",
            "TRADE_REWARD_PROGRAM",
            "AUTOMATED_OFFER"
          ]
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 3
        }
      ],
      "concreteType": "ActivityFeedConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ActivityFeedEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ActivityFeedElement",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "type",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "eventDate",
                  "args": null,
                  "storageKey": null
                },
                (v0/*: any*/)
              ]
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "ActivityFeed_feed",
          "args": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "preferences",
      "storageKey": null,
      "args": null,
      "concreteType": "UserPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "shareActivities",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ShareActivityAlert_user",
      "args": null
    }
  ]
};
})();
(node as any).hash = 'f778faaebed25de22b78030301a4580d';
export default node;
